import { Checkbox } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import React from 'react';

import { useAction, useStakeholderReference } from '@hooks';

export interface AlertChangeCheckboxProps {
	stakeholderId: number;
}

export const AlertChangeCheckbox: React.FC<AlertChangeCheckboxProps> = ({ stakeholderId }) => {
	const stakeholder = useStakeholderReference(stakeholderId);

	const update = useAction(coreActions.requestPatchCoreStakeholders);

	return (
		<Checkbox
			checked={ stakeholder.alertMetadataChanges }
			onChange={ () => update({
				alertMetadataChanges: !stakeholder.alertMetadataChanges,
				stakeholderId
			}) } />
	);
};
